import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/steveeeie/react-css-3d/src/docs/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Examples`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-css-3d/box-example"
        }}>{`Box Example`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-css-3d/room-example"
        }}>{`Room Example`}</a></li>
    </ul>
    <hr></hr>
    <h2>{`Installation`}</h2>
    <pre><code parentName="pre" {...{}}>{`npm install @react-css-3d
`}</code></pre>
    <hr></hr>
    <h2>{`Motivation`}</h2>
    <p>{`Over the years I have created a number of 3D scenes using only `}<inlineCode parentName="p">{`CSS`}</inlineCode>{` / `}<inlineCode parentName="p">{`HTML`}</inlineCode>{` so I decided to publish a library to make this easier for me. The library is `}<inlineCode parentName="p">{`CSS`}</inlineCode>{` / `}<inlineCode parentName="p">{`HTML`}</inlineCode>{` based, for this reason its capabilities are limited. You shouldn’t expect the same levels of fidelity as a WebGL based solution.`}</p>
    <hr></hr>
    <h2>{`Browser Support`}</h2>
    <p>{`The library is supported by most evergreen browsers, however as each browser handles css-transformations differently you may experience varying frame rates and quality. `}<strong parentName="p">{`The library makes heavy use of the `}<inlineCode parentName="strong">{`preserve-3d`}</inlineCode>{` transform-style which is not supported by any version of IE.`}</strong></p>
    <hr></hr>
    <h2>{`Available Components`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Scene`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`Group`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`Box`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`Plane`}</inlineCode></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      